import { render, staticRenderFns } from "./picker-goodsParams.vue?vue&type=template&id=6c7af625"
import script from "./picker-goodsParams.vue?vue&type=script&lang=js"
export * from "./picker-goodsParams.vue?vue&type=script&lang=js"
import style0 from "./picker-goodsParams.vue?vue&type=style&index=0&id=6c7af625&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports